module.exports = __webpack_public_path__ + "static/media/ACA.8e878e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ACA.png
// module id = 849
// module chunks = 0